module.exports = __webpack_public_path__ + "media/chemistry.1dbf7f45.mp4";